import React from "react";

const BS5_Jumbotron = () => {
  return (
    <div className="container mt-4">
      <h2>BS5_Jumbotron Component</h2>
      <p>This is the BS5_Jumbotron component for Bootstrap 5 tutorial.</p>
    </div>
  );
};

export default BS5_Jumbotron;
